
import Dashboard from 'components/General/Dashboard/Dashboard';
import AdminList from 'components/Admin/Administrators/AdminList';
import {BrowserRouter as Router , Route, Routes, Navigate} from 'react-router-dom'
import Cookies from 'universal-cookie';
import CompanyList from 'components/Admin/Companies/CompanyList';
import PlanList from 'components/Admin/Plans/PlanList';
import Warehouses from 'components/Inventory/Warehouses/WarehouseList'; 
import Products from 'components/Inventory/Products/ProductsList';
import Categories from 'components/Inventory/Categories/CategoriesList';
import Suppliers from 'components/Inventory/Suppliers/SuppliersList';
import Brands from 'components/Inventory/Brands/BrandsList';
import ParentProducts from 'components/Inventory/ParentProducts/ParentProductsList';
import Vehicles from 'components/Routes/Vehicles/VehiclesList';
import Users from 'components/General/Users/UsersList';
import Sync from 'components/General/Import/Sync';
import ReportsInventory from 'components/Reports/ReportsInventory';
import MovementsConcepts from 'components/Inventory/MovementsConcepts/ConceptsList';
import Guides from 'components/Routes/Guides/GuideList';
import GuideRoutesList from 'components/Routes/Guides/GuideRoutesList';
import Movements from 'components/Inventory/Movements/MovementList';
import Notifications from 'components/General/Notifications/NotificationsList';
import Companies from 'components/Admin/Companies/CompanyList';
import Administrators from 'components/Admin/Administrators/AdminList';
import Plans from 'components/Admin/Plans/PlanList';
import Debt from 'components/Debt/Debt/ClientList';
import DebtReports from 'components/Reports/DebtReports' 
import PaymentMethods from 'components/Routes/PaymentMethods/PaymentMethodsList';
import Payments from 'components/Debt/Payments/PaymentsList';
import CitiesList from 'components/Admin/SystemCities/CitiesList';
import RegionsList from 'components/Admin/SystemCities/RegionsList';
import RoutesReports from './components/Reports/RoutesReports';
import MapRoutes from 'components/Routes/Map/Map'; 
import Configuration from 'components/General/Configuration/Configuration';
import Portfolios from 'components/Inventory/Portfolios/PortfoliosList';
import PurchaseOrders from 'components/Inventory/PurchaseOrders/PurchaseOrdersList';
import PurchaseOrderDetails from 'components/Inventory/PurchaseOrders/PurchaseOrderDetails';
import Budgets from 'components/Orders/Budgets/BudgetsList';
import BudgetDetail from 'components/Orders/Budgets/BudgetDetail';

//ORDERS
import Orders from 'components/Orders/Orders/OrdersList';
import OrdersReports from './components/Reports/OrdersReports';
import Assets from 'components/Orders/Assets/AssetsList'; 
import OrdersConcepts from 'components/Orders/OrdersConcepts/OrdersConceptList';
import Clients from 'components/Orders/Clients/ClientsList';
import UndeliveredConcepts from 'components/Orders/UndeliveredConcepts/UndeliveredConceptList';
import Map from 'components/Orders/Map/Map';
import Typology from 'components/Orders/Typology/TypologyList';
import Neighborhoods from 'components/Orders/Neighborhoods/NeighborhoodList';
import Cities from 'components/Orders/Cities/CitiesList';

//PURCHASES 
import PurchasesOrders from 'components/Purchases/Orders/OrdersList';
import PurchasesReports from './components/Reports/PurchasesReports';
import PurchasesAssets from 'components/Purchases/Assets/AssetsList'; 
import PurchasesClients from 'components/Purchases/Clients/ClientsList';
import PurchasesBudgets from 'components/Purchases/Budgets/BudgetsList';
import PurchasesMap from 'components/Purchases/Map/Map';

import Catalogs from 'components/General/Catalogs/CatalogsList';
import Picking from 'components/Routes/Picking/PickingList';
import PickingDetails from 'components/Routes/Picking/PickingDetails';
import Messages from 'components/General/Messages/MessagesList';
import Maintenance from 'components/Admin/Maintenance/Maintenance';
import AdminReports from 'components/Admin/Reports/AdminReports';
import SafetyAlertsList from 'components/General/SafetyAlerts/SafetyAlertsList';
import BackupsList from 'components/Admin/Backups/BackupsList';
import AccesosReports from 'components/Reports/AccesosReports';

//DIAN
import DianConfiguration from 'components/Invoicing/Dian/DianConfiguration';
import DianDocuments from 'components/Invoicing/Dian/DianDocuments';
import DianResolutions from 'components/Invoicing/Dian/DianResolutions';

//FACTURAS
import InvoiceList from 'components/Invoicing/Facturas/InvoiceList';
import InvoiceCreator from 'components/Invoicing/Facturas/InvoiceCreator';
import InvoiceViewer from 'components/Invoicing/Facturas/InvoiceViewer';

//FAQ
import FaqList from 'components/General/Faq/FaqList';
import FaqViewer from 'components/General/Faq/FaqViewer';

//CORRECCIONES (Temporal)
import Corrections from 'components/General/Corrections/Corrections';


const cookies = new Cookies();
 
const componentMap: any = {
  Dashboard,
  Warehouses,
  Products,
  Categories,
  Suppliers,
  Brands,
  ParentProducts,
  Vehicles,
  Users,
  Sync,
  ReportsInventory,
  AdminList,
  CompanyList,
  PlanList,
  Clients, 
  MovementsConcepts, 
  UndeliveredConcepts,
  Assets,
  Guides,
  GuideRoutesList,
  Movements,
  Notifications,
  Companies,
  Administrators,
  Plans,
  Debt,
  DebtReports,
  PaymentMethods,
  Payments,
  CitiesList,
  RegionsList,
  Orders,
  OrdersReports,
  RoutesReports,
  Map,
  Typology,
  Neighborhoods,
  Cities,
  Configuration,
  OrdersConcepts,
  MapRoutes,
  Portfolios,
  PurchaseOrders,
  PurchaseOrderDetails,
  Budgets,
  BudgetDetail,
  
  PurchasesOrders,
  PurchasesReports,
  PurchasesAssets,
  PurchasesClients,
  PurchasesMap,
  PurchasesBudgets,
  
  Catalogs,

  Picking,
  PickingDetails,

  Messages,

  Maintenance,

  AdminReports,

  SafetyAlertsList,

  BackupsList,
  
  AccesosReports,

  DianConfiguration,
  DianDocuments,
  DianResolutions,

  InvoiceList,

  FaqList,

  FaqViewer,

  Corrections,
}


export default function AppRoutes(props:any) {

  const role_id = Number(localStorage.getItem('role_id'));
  const {setLoading, permissions} = props;
  
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/debt" element={<Debt setLoading={setLoading}/>} />
        <Route path="/guides/routes/:guide_id" element={<GuideRoutesList setLoading={setLoading}/>} />
        <Route path="/purchaseorders/details/:purchase_order_id" element={<PurchaseOrderDetails setLoading={setLoading}/>} />
        <Route path="/budgets/details/:budget_id" element={<BudgetDetail setLoading={setLoading}/>} />
        <Route path="/picking/details/:guide_code" element={<PickingDetails setLoading={setLoading}/>} />
        <Route path="/invoicing/facturas/crear" element={<InvoiceCreator setLoading={setLoading}/>} />
        <Route path="/invoicing/facturas/ver/:id" element={<InvoiceViewer setLoading={setLoading}/>} />
        <Route path="/safety-alerts/details/:alert_id" element={<SafetyAlertsList setLoading={setLoading}/>} />
        {permissions.map((route:any, index:any) => {
          return route.components.map((item:any, index:any) => {
            const Component = componentMap[item.component];
            return <Route path={item.path} element={<Component setLoading={setLoading}/>} />
          })
        })}
      </Routes>
    </>

  );
}
